export default __webpack_public_path__ + "static/media/maternalRecord.3f094c54.png";